<h2 mat-dialog-title mat-dialog-draggable-title>
  {{'title.attach_file_list' | translate}}
  <button type="button" (click)="onNoClick()" class="close" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<mat-dialog-content class="pb-2 pt-2">
  <mat-accordion #accordion="matAccordion" [multi]="true">
    <!-- <mat-expansion-panel expanded="true"> -->
    <mat-expansion-panel expanded="true"  *ngIf="data.attachments.length !== 0 ;">
      <mat-expansion-panel-header>
        <mat-panel-title class="mat-panel-title">
          {{'title.attach_file_list_of_customer' | translate}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-container *ngIf="data.attachments.length !== 0 ; else notData">
          <div *ngFor="let item of data.attachments; let i = index" class="w-100">

            <div class="checkbox checkbox-info w-100">
              <div class="row ml-1">
                <div class="col-8">
                  <input id="item{{i}}" class="styled" type="checkbox" (change)="checkboxChange(i)" 
                    [(ngModel)]="item.active" name="active" class="form-check-input">
                  <label for="item{{i}}"><span class="fix-width">{{item.fileName}}</span></label>
                </div>

                <div class="col-4 text-right">
                  <span>{{item.fileSize | byte}}</span>
                </div>
              </div>
            </div>
          </div>
      </ng-container>

      <ng-template #notData class="pl-3">
        {{'messages.not_list_attach_file' | translate }}
      </ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel expanded="true">
      <mat-expansion-panel-header>
        <mat-panel-title class="mat-panel-title">
          {{'title.attach_file_form_local' | translate}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-upload-multi-file (hasChange)="onNewUploadChange($event)" [isAttachFileForDocument]="true"
        [arrAttachments]="newUploadContractAttachments" (click)="onClickUpload()"></app-upload-multi-file>
      <mat-error class="text-error" *ngIf="duplicatedUploadFileNames?.length > 0">
        <span>{{duplicatedUploadFileTitle}}</span>
        <ul>
          <li *ngFor="let err of duplicatedUploadFileNames">
            {{err}}
          </li>
        </ul>
      </mat-error>
      <mat-hint class="hint-text">
        {{'hint.attach_accept_pdf_image' | translate}}
      </mat-hint>
    </mat-expansion-panel>
  </mat-accordion>
</mat-dialog-content>
<mat-dialog-actions align="center" class="mt-2">
  <button mat-stroked-button color="primary" type="button" (click)="onNoClick()">
    <mat-icon class="mr-0">cancel</mat-icon>{{'button.cancel' | translate}}
  </button>
  <button class="ml-2" [disabled]="!isFormChanging" mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>
    <mat-icon class="mr-0">done</mat-icon>{{'button.accept' | translate}}
  </button>
</mat-dialog-actions>